@if (offer?.file) {
  <div class="offer-image-container">
    <img
      [src]="imagesUrl + (showFullImage ? '' : 'thumb/') + offer.file"
      [alt]="offer.title || 'Offer image'"
      loading="lazy"
      [class]="'offer-image ' + imageClass" />
    <!-- Discount/Promo overlay at the bottom -->
    @if (offer.discount || offer.promotext) {
      <div class="offer-overlay">
        @if (offer.partner_file) {
          <div  class="partner-logo-holder">
            <div class="partner-logo-holder-img">
              <img
                (click)="goToPartner(offer)"
                [src]="partnerImagesUrl + 'thumb/' + offer.partner_file"
                [alt]="offer.partner_name || 'Partner logo'"
                class="partner-logo"
                loading="lazy" />
              </div>
          </div>
        }
        @if (offer.discount) {
          <div class="discount-text">
            {{ offer.discount }}
          </div>
        }
      </div>
    }
  </div>
}

<!-- Fallback when no image -->
@if (!offer?.file) {
  <div class="no-image-placeholder">
    <span>Brak zdjęcia</span>
  </div>
}